import {
  getMembersQueryKey,
  useInviteMember,
  useMembers,
  useRemoveMember,
  useResendInvite,
  useRevokeInvite,
  useUpdateMember,
} from "../../api/endpoint.js";
import { keepPreviousData, useQueryClient } from "@tanstack/react-query";
import { USER_ROW_LIMIT } from "../constants.js";
import {
  useUsersManagementContext,
  type UsersManagementContextType,
} from "../users-management-context.js";

export const useUsers = (context?: UsersManagementContextType) => {
  const {
    state: { pagination, role, searchQuery },
  } = useUsersManagementContext(context);
  const limit = USER_ROW_LIMIT;
  const { before, after } = pagination || {};

  return useMembers(
    {
      after: after ?? undefined,
      before: before ?? undefined,
      limit: limit.toString(),
      role: role ?? undefined,
      search: searchQuery ?? undefined,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
};

export const useUpdateUserRole: typeof useUpdateMember = () => {
  const queryClient = useQueryClient();

  return useUpdateMember({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getMembersQueryKey() });
      },
    },
  });
};

export const useInviteUser: typeof useInviteMember = () => {
  const queryClient = useQueryClient();

  return useInviteMember({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getMembersQueryKey() });
      },
    },
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useRemoveMember({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getMembersQueryKey() });
      },
    },
  });
};

export const useRevokeUserInvite = () => {
  const queryClient = useQueryClient();

  return useRevokeInvite({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getMembersQueryKey() });
      },
    },
  });
};

export const useResendUserInvite = () => {
  const queryClient = useQueryClient();

  return useResendInvite({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getMembersQueryKey() });
      },
    },
  });
};
